import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Paperclip: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M10 22.36A7.36 7.36 0 0 1 4.79 9.79l6.5-6.5a5.25 5.25 0 0 1 7.42 7.42l-6.5 6.5a3.14 3.14 0 0 1-4.42 0 3.14 3.14 0 0 1 0-4.42l6.5-6.5a1 1 0 1 1 1.42 1.42l-6.5 6.5a1.12 1.12 0 0 0 1.58 1.58l6.5-6.5a3.24 3.24 0 0 0 0-4.58 3.23 3.23 0 0 0-4.58 0l-6.5 6.5a5.36 5.36 0 0 0 7.58 7.58l6.5-6.5a1 1 0 0 1 1.42 1.42l-6.5 6.5A7.37 7.37 0 0 1 10 22.36Z" />
  </Icon>
);

export default Paperclip;
